<!-- NOTE: 完全に必要ないことが確認できたら削除する -->

<!-- TODO: 画面が全部終わったら全体的に直したい -->
<template>
  <!-- NOTE: この画面に「noselect」は必要？ -->
  <div class="home" variant="mypage">
    <b-container>
      <!-- 画面全体 -->
      <b-row class="flex-xl-nowrap2">
        <!-- サイドメニュー -->
        <b-col cols="3" class="bd-sidebar border-bottom-0">
            <MypageSideMenu />
        </b-col>
        <!-- スケジュール -->
        <b-col cols="9" class="bd-content col-md-9 col-xl-9 col-12 pb-md-3 pl-md-3">
          <main class="bd-main bd-components">
            <h5 class="lead border-title pl-2">スケジュール</h5>
            <!-- 予定の登録 -->
            <b-row class="ml-2 mb-2">
              <!-- 予定の登録 -->
              <b-col sm="12" md="12" xl="auto" class="mt-2 p-4">
                <h6>予定の登録</h6>
                <div class="d-flex align-items-center justify-content-left mt-4">
                  <label class="mb-0 mr-2">日付</label>
                  <b-form-select
                    class="form-control w-auto"
                    :options="year"
                    v-model="plansFarstYearSelected"
                    @input="plansFarstSelect"
                  />
                  <label class="mb-0 ml-2 mr-2">年</label>
                  <b-form-select v-model="plansFarstMonSelected" @input="plansFarstSelect" class="form-control w-auto">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                    <option>10</option>
                    <option>11</option>
                    <option>12</option>
                  </b-form-select>
                  <label class="mb-0 ml-2 mr-2">月</label>
                  <b-form-select
                    class="form-control w-auto"
                    :options="plansFarstDay"
                    v-model="plansFarstDaySelect"
                  />
                   <label class="mb-0 ml-2 mr-2">日</label>
                </div>
                <div class="d-flex align-items-center justify-content-left mt-2 ml-2">
                  <label class="mb-0 ml-2 mr-2">〜</label>
                  <b-form-select
                    class="form-control w-auto"
                    :options="year"
                    v-model="plansLastYearSelected"
                    @input="plansLastSelect"
                  />
                  <label class="mb-0 ml-2 mr-2">年</label>
                  <b-form-select v-model="plansLastMonSelected" @input="plansLastSelect" class="form-control w-auto">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                    <option>10</option>
                    <option>11</option>
                    <option>12</option>
                  </b-form-select>
                  <label class="mb-0 ml-2 mr-2">月</label>
                  <b-form-select
                    class="form-control w-auto"
                    :options="plansLastDay"
                    v-model="plansLastDaySelect"
                  />
                  <label class="mb-0 ml-2 mr-2">日</label>
                </div>
                <div class="d-flex align-items-center justify-content-left mt-2">
                  <label class="mb-0 mr-2">時間</label>
                  <b-form-input type="text" id="text1" style="width: 50px;" v-model="plansFarstTimeFarstInput" />
                  <label class="mb-0 ml-2 mr-2">:</label>
                  <b-form-input type="text" id="text1" style="width: 50px;" v-model="plansFarstTimeLastInput" />
                  <label class="mb-0 ml-2 mr-2">〜</label>
                  <b-form-input type="text" id="text1" style="width: 50px;" v-model="plansLastTimeFarstInput" />
                  <label class="mb-0 ml-2 mr-2">:</label>
                  <b-form-input type="text" id="text1" style="width: 50px;" v-model="plansLastTimeLastInput" />
                </div>
                <div class="d-flex align-items-center justify-content-left mt-2">
                  <label class="mb-0 mr-2">お名前</label>
                  <b-form-input type="text" id="text1" class="w-100" v-model="plansNameTextInput" />
                </div>
                <div class="d-flex align-items-center justify-content-left mt-2">
                  <label class="mb-0 mr-2">予定種別</label>
                  <b-form-select class="form-control w-auto" v-model="plansType">
                    <option value="0">無し</option>
                    <option value="1">外出</option>
                    <option value="2">出張</option>
                    <option value="3">離席</option>
                    <option value="4">その他</option>
                  </b-form-select>
                </div>
                <div class="mt-2">
                  <label class="mb-0 mr-2">内容</label>
                  <b-form-textarea class="form-control w-100" rows="8" v-model="plansContentInput" />
                </div>
                <div class="d-flex align-items-center justify-content-left mt-2">
                  <label class="mb-0 mr-2">期間終了後1週間で削除</label>
                  <b-form-checkbox
                    v-model="plansDeleteFlag"
                    value="1"
                    unchecked-value="0"
                  />
                </div>
                <b-button variant="danger" @click="plansRegister">予定を登録</b-button>
              </b-col>
              <!-- 現在の予定 -->
              <b-col sm="12" md="12" xl="6" class="mt-2 p-4">
                <h6>現在の予定</h6>
                <div class="border overflow-auto rounded-lg p-2" style="height: 600px;">
                  <div class="p-2 border-bottom d-flex" v-for="(item, index) in currentlyScheduledList" :key="index">
                    <div>
                      <p class="m-0 mb-1">日付: <span class="small">{{new Date(item.farstDate).getFullYear() + '年' + new Date(item.farstDate).getMonth() + '月' + new Date(item.farstDate).getDate() + '日'}} 〜 {{new Date(item.lastDate).getFullYear() + '年' + new Date(item.lastDate).getMonth() + '月' + new Date(item.lastDate).getDate() + '日'}}</span></p>
                      <p class="m-0 mb-1">時間: <span class="small">{{item.farstTime}} 〜 {{item.lastTime}}</span></p>
                      <p class="m-0 mb-1">お名前: <span class="small">{{item.name}}</span></p>
                      <p class="m-0 mb-1">予定種別: <span class="small">{{item.type === 0 ? '無し' : item.type === 1 ? '外出' : item.type === 2 ? '出張': item.type === 3 ? '離席': 'その他'}}</span></p>
                      <p class="m-0 mb-1">内容: <span class="small">{{item.content}}</span></p>
                    </div>
                    <div class="ml-2 d-flex align-items-center">
                      <b-button variant="danger" @click="plansEdit(index)">編集</b-button>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
            <!-- 特定の方からの連絡に対応する応対登録 -->
            <b-row class="ml-2">
             <b-col sm="12" md="12" xl="auto" class="mt-2 p-4">
                <h6>特定の方からの連絡に対応する応対登録</h6>
                <div class="d-flex align-items-center justify-content-left mt-4">
                  <label class="mb-0 mr-2">日付</label>
                  <b-form-select
                    class="form-control w-auto"
                    :options="year"
                    v-model="receptionFarstYearSelected"
                    @input="receptionFarstSelect"
                  />
                  <label class="mb-0 ml-2 mr-2">年</label>
                  <b-form-select v-model="receptionFarstMonSelected" @input="receptionFarstSelect" class="form-control w-auto">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                    <option>10</option>
                    <option>11</option>
                    <option>12</option>
                  </b-form-select>
                  <label class="mb-0 ml-2 mr-2">月</label>
                  <b-form-select
                    class="form-control w-auto"
                    :options="receptionFarstDay"
                    v-model="receptionFarstDaySelect"
                  />
                   <label class="mb-0 ml-2 mr-2">日</label>
                </div>
                <div class="d-flex align-items-center justify-content-left mt-2 ml-2">
                  <label class="mb-0 ml-2 mr-2">〜</label>
                  <b-form-select
                    class="form-control w-auto"
                    :options="year"
                    v-model="receptionLastYearSelected"
                    @input="receptionLastSelect"
                  />
                  <label class="mb-0 ml-2 mr-2">年</label>
                  <b-form-select v-model="receptionLastMonSelected" @input="receptionLastSelect" class="form-control w-auto">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                    <option>10</option>
                    <option>11</option>
                    <option>12</option>
                  </b-form-select>
                  <label class="mb-0 ml-2 mr-2">月</label>
                  <b-form-select
                    class="form-control w-auto"
                    :options="receptionLastDay"
                    v-model="receptionLastDaySelect"
                  />
                  <label class="mb-0 ml-2 mr-2">日</label>
                </div>
                <div class="d-flex align-items-center justify-content-left mt-2">
                  <label class="mb-0 mr-2">相手先お名前</label>
                  <b-form-input type="text" id="text1" class="w-100" v-model="receptionName" />
                </div>
                <div class="d-flex align-items-center justify-content-left mt-2">
                  <label class="mb-0 mr-2">相手先性別</label>
                  <b-form-select class="form-control w-auto" v-model="receptionGender">
                    <option value="0">男性</option>
                    <option value="1">女性</option>
                  </b-form-select>
                </div>
                <div class="mt-2">
                  <label class="mb-0 mr-2">お伝えする内容</label>
                  <b-form-textarea class="form-control w-100" rows="8" v-model="receptionContentInput" />
                </div>
                <div class="d-flex align-items-center justify-content-left mt-2">
                  <label class="mb-0 mr-2">指示担当者</label>
                  <b-form-input type="text" id="text1" class="w-100" v-model="personInChargeInput" />
                </div>
                <div class="d-flex align-items-center justify-content-left mt-2">
                  <label class="mb-0 mr-2">登録日</label>
                  <b-form-input disabled type="text" id="text1" style="width: 70px;" v-model="receptionYearDate" />
                  <label class="mb-0 ml-2 mr-2">年</label>
                  <b-form-input disabled type="text" id="text1" style="width: 50px;" v-model="receptionMonDate" />
                  <label class="mb-0 ml-2 mr-2">月</label>
                  <b-form-input disabled type="text" id="text1" style="width: 50px;" v-model="receptionDayDate"/>
                  <label class="mb-0 ml-2 mr-2">日</label>
                </div>
                <div class="d-flex align-items-center justify-content-left mt-2">
                  <label class="mb-0 mr-2">期間終了後1週間で削除</label>
                  <b-form-checkbox
                    v-model="receptionDeleteFlag"
                    value="1"
                    unchecked-value="0"
                  />
                </div>
                <b-button variant="danger" @click="receptionRegister">応対を登録</b-button>
              </b-col>
              <b-col sm="12" md="12" xl="6" class="mt-2 p-4">
                <h6>現在の内容</h6>
                <div class="border overflow-auto rounded-lg p-2" style="height: 600px;">
                  <div class="p-2 border-bottom d-flex" v-for="(item, index) in receptionScheduledList" :key="index">
                    <div>
                      <p class="m-0 mb-1">日付: <span class="small">{{new Date(item.farstDate).getFullYear() + '年' + new Date(item.farstDate).getMonth() + '月' + new Date(item.farstDate).getDate() + '日'}} 〜 {{new Date(item.lastDate).getFullYear() + '年' + new Date(item.lastDate).getMonth() + '月' + new Date(item.lastDate).getDate() + '日'}}</span></p>
                      <p class="m-0 mb-1">相手先お名前: <span class="small">{{item.partnerName}}</span></p>
                      <p class="m-0 mb-1">相手先性別: <span class="small">{{item.partnerGender === 0 ? '男' : '女'}}</span></p>
                      <p class="m-0 mb-1">お伝えする内容: <span class="small">{{item.content}}</span></p>
                      <p class="m-0 mb-1">指示担当者: <span class="small">{{item.personInCharge}}</span></p>
                      <p class="m-0 mb-1">指示日: <span class="small">{{new Date(item.orderDate).getFullYear() + '年' + new Date(item.orderDate).getMonth() + '月' + new Date(item.orderDate).getDate() + '日'}}</span></p>
                    </div>
                    <div class="ml-2 d-flex align-items-center">
                      <b-button variant="danger" @click="receptionEdit(index)">編集</b-button>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </main>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import MypageSideMenu from '../../components/MypageSideMenu'

export default {
  components: { MypageSideMenu },
  data () {
    return {
      currentlyScheduledList: [],
      receptionScheduledList: [],
      year: [],

      plansFarstDay: [],
      plansLastDay: [],
      plansFarstYearSelected: null,
      plansLastYearSelected: null,
      plansFarstMonSelected: null,
      plansLastMonSelected: null,
      plansFarstDaySelect: null,
      plansLastDaySelect: null,
      plansFarstTimeFarstInput: null,
      plansFarstTimeLastInput: null,
      plansLastTimeFarstInput: null,
      plansLastTimeLastInput: null,
      plansNameTextInput: '',
      plansType: 0,
      plansContentInput: '',
      plansDeleteFlag: 0,

      receptionFarstDay: [],
      receptionLastDay: [],
      receptionFarstYearSelected: null,
      receptionLastYearSelected: null,
      receptionFarstMonSelected: null,
      receptionLastMonSelected: null,
      receptionFarstDaySelect: null,
      receptionLastDaySelect: null,
      receptionName: '',
      receptionGender: 0,
      receptionContentInput: '',
      personInChargeInput: '',
      receptionYearDate: '',
      receptionMonDate: '',
      receptionDayDate: '',
      receptionDeleteFlag: 0
    }
  },
  computed: {
  },
  mounted () {
    this.start()
  },
  methods: {
    start () {
      // NOTE: APIを読み込んだ後に入れる（現在は仮でmocデータを入れる）
      this.currentlyScheduledList = [
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'farstTime': '10:10',
          'lastTime': '11:10',
          'name': 'テスト 太郎',
          'type': 0,
          'content': 'テスト',
          'deleteFlag': 0
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'farstTime': '10:10',
          'lastTime': '11:10',
          'name': 'テスト 太郎',
          'type': 1,
          'content': 'テスト',
          'deleteFlag': 1
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'farstTime': '10:10',
          'lastTime': '11:10',
          'name': 'テスト 太郎',
          'type': 2,
          'content': 'テスト',
          'deleteFlag': 0
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'farstTime': '10:10',
          'lastTime': '11:10',
          'name': 'テスト 太郎',
          'type': 3,
          'content': 'テスト',
          'deleteFlag': 0
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'farstTime': '10:10',
          'lastTime': '11:10',
          'name': 'テスト 太郎',
          'type': 0,
          'content': 'テスト',
          'deleteFlag': 0
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'farstTime': '10:10',
          'lastTime': '11:10',
          'name': 'テスト 太郎',
          'type': 0,
          'content': 'テスト',
          'deleteFlag': 0
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'farstTime': '10:10',
          'lastTime': '11:10',
          'name': 'テスト 太郎',
          'type': 0,
          'content': 'テスト',
          'deleteFlag': 0
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'farstTime': '10:10',
          'lastTime': '11:10',
          'name': 'テスト 太郎',
          'type': 0,
          'content': 'テスト',
          'deleteFlag': 0
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'farstTime': '10:10',
          'lastTime': '11:10',
          'name': 'テスト 太郎',
          'type': 0,
          'content': 'テスト',
          'deleteFlag': 0
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'farstTime': '10:10',
          'lastTime': '11:10',
          'name': 'テスト 太郎',
          'type': 0,
          'content': 'テスト',
          'deleteFlag': 0
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'farstTime': '10:10',
          'lastTime': '11:10',
          'name': 'テスト 太郎',
          'type': 0,
          'content': 'テスト',
          'deleteFlag': 0
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'farstTime': '10:10',
          'lastTime': '11:10',
          'name': 'テスト 太郎',
          'type': 0,
          'content': 'テスト',
          'deleteFlag': 0
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'farstTime': '10:10',
          'lastTime': '11:10',
          'name': 'テスト 太郎',
          'type': 0,
          'content': 'テスト',
          'deleteFlag': 0
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'farstTime': '10:10',
          'lastTime': '11:10',
          'name': 'テスト 太郎',
          'type': 0,
          'content': 'テスト',
          'deleteFlag': 0
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'farstTime': '10:10',
          'lastTime': '11:10',
          'name': 'テスト 太郎',
          'type': 0,
          'content': 'テスト',
          'deleteFlag': 0
        }
      ]
      this.receptionScheduledList = [
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'partnerName': 'テスト 太郎',
          'partnerGender': 0,
          'content': 'テスト',
          'personInCharge': 'テスト 花子',
          'orderDate': '2020/03/11',
          'deleteFlag': 0
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'partnerName': 'テスト 太郎',
          'partnerGender': 1,
          'content': 'テスト',
          'personInCharge': 'テスト 花子',
          'orderDate': '2020/03/11',
          'deleteFlag': 1
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'partnerName': 'テスト 太郎',
          'partnerGender': 0,
          'content': 'テスト',
          'personInCharge': 'テスト 花子',
          'orderDate': '2020/03/11',
          'deleteFlag': 0
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'partnerName': 'テスト 太郎',
          'partnerGender': 0,
          'content': 'テスト',
          'personInCharge': 'テスト 花子',
          'orderDate': '2020/03/11',
          'deleteFlag': 0
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'partnerName': 'テスト 太郎',
          'partnerGender': 0,
          'content': 'テスト',
          'personInCharge': 'テスト 花子',
          'orderDate': '2020/03/11',
          'deleteFlag': 0
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'partnerName': 'テスト 太郎',
          'partnerGender': 0,
          'content': 'テスト',
          'personInCharge': 'テスト 花子',
          'orderDate': '2020/03/11',
          'deleteFlag': 0
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'partnerName': 'テスト 太郎',
          'partnerGender': 0,
          'content': 'テスト',
          'personInCharge': 'テスト 花子',
          'orderDate': '2020/03/11',
          'deleteFlag': 0
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'partnerName': 'テスト 太郎',
          'partnerGender': 0,
          'content': 'テスト',
          'personInCharge': 'テスト 花子',
          'orderDate': '2020/03/11',
          'deleteFlag': 0
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'partnerName': 'テスト 太郎',
          'partnerGender': 0,
          'content': 'テスト',
          'personInCharge': 'テスト 花子',
          'orderDate': '2020/03/11',
          'deleteFlag': 0
        },
        {
          'farstDate': '2020/03/12',
          'lastDate': '2020/03/13',
          'partnerName': 'テスト 太郎',
          'partnerGender': 0,
          'content': 'テスト',
          'personInCharge': 'テスト 花子',
          'orderDate': '2020/03/11',
          'deleteFlag': 0
        }
      ]
      // NOTE: 年を表示（※一旦現在から2年先まで選択可能）
      const year = new Date().getFullYear()
      for (let i = 0; i <= 2; i++) {
        this.year.push(year + i)
      }
    },
    // NOTE: 予定登録の「plansFarstDay」を調べる
    plansFarstSelect () {
      if (this.plansFarstYearSelected && this.plansFarstMonSelected) {
        const endOfMonth = new Date(parseInt(Number(this.plansFarstYearSelected), 10), parseInt(Number(this.plansFarstMonSelected), 10), 0).getDate()
        if (endOfMonth) {
          this.plansFarstDay = []
          // this.plansFarstDaySelect = null
          for (let i = 1; i <= endOfMonth; i++) {
            this.plansFarstDay.push(i)
          }
        }
      }
    },
    // NOTE: 予定登録の「plansLastDay」を調べる
    plansLastSelect () {
      if (this.plansLastYearSelected && this.plansLastMonSelected) {
        const endOfMonth = new Date(parseInt(Number(this.plansLastYearSelected), 10), parseInt(Number(this.plansLastMonSelected), 10), 0).getDate()
        if (endOfMonth) {
          this.plansLastDay = []
          // this.plansLastDaySelect = null
          for (let i = 1; i <= endOfMonth; i++) {
            this.plansLastDay.push(i)
          }
        }
      }
    },
    // NOTE: 応対登録の「receptionFarstDay」を調べる
    receptionFarstSelect () {
      if (this.receptionFarstYearSelected && this.receptionFarstMonSelected) {
        const endOfMonth = new Date(parseInt(Number(this.receptionFarstYearSelected), 10), parseInt(Number(this.receptionFarstMonSelected), 10), 0).getDate()
        if (endOfMonth) {
          this.receptionFarstDay = []
          // this.receptionFarstDaySelect = null
          for (let i = 1; i <= endOfMonth; i++) {
            this.receptionFarstDay.push(i)
          }
        }
      }
    },
    // NOTE: 応対登録の「receptionLastDay」を調べる
    receptionLastSelect () {
      if (this.receptionLastYearSelected && this.receptionLastMonSelected) {
        const endOfMonth = new Date(parseInt(Number(this.receptionLastYearSelected), 10), parseInt(Number(this.receptionLastMonSelected), 10), 0).getDate()
        if (endOfMonth) {
          this.receptionLastDay = []
          // this.receptionLastDaySelect = null
          for (let i = 1; i <= endOfMonth; i++) {
            this.receptionLastDay.push(i)
          }
        }
      }
    },
    // TODO: 予定の登録処理
    plansRegister () {
      console.log(this.plansFarstYearSelected)
      console.log(this.plansLastYearSelected)
      console.log(this.plansFarstMonSelected)
      console.log(this.plansLastMonSelected)
      console.log(this.plansFarstDaySelect)
      console.log(this.plansLastDaySelect)
      console.log(this.plansFarstTimeFarstInput)
      console.log(this.plansFarstTimeLastInput)
      console.log(this.plansLastTimeFarstInput)
      console.log(this.plansLastTimeLastInput)
      console.log(this.plansNameTextInput)
      console.log(this.plansType)
      console.log(this.plansContentInput)
    },
    // TODO: 応対の登録処理
    receptionRegister () {
      console.log(this.receptionFarstYearSelected)
      console.log(this.receptionLastYearSelected)
      console.log(this.receptionFarstMonSelected)
      console.log(this.receptionLastMonSelected)
      console.log(this.receptionFarstDaySelect)
      console.log(this.receptionLastDaySelect)
      console.log(this.receptionName)
      console.log(this.receptionGender)
      console.log(this.receptionContentInput)
      console.log(this.personInChargeInput)
      console.log(this.receptionDeleteFlag)

      // NOTE: 登録日を出力
      const receptionRegisterDate = new Date()
      this.receptionYearDate = new Date(receptionRegisterDate).getFullYear()
      this.receptionMonDate = new Date(receptionRegisterDate).getMonth()
      this.receptionDayDate = new Date(receptionRegisterDate).getDate()

      console.log(this.receptionYearDate)
      console.log(this.receptionMonDate)
      console.log(this.receptionDayDate)
    },
    // TODO: 予定の編集
    plansEdit (index) {
      const farstDate = new Date(this.currentlyScheduledList[index].farstDate)
      const lastDate = new Date(this.currentlyScheduledList[index].lastDate)
      this.plansFarstYearSelected = new Date(farstDate).getFullYear()
      this.plansFarstMonSelected = new Date(farstDate).getMonth()
      this.plansFarstDaySelect = new Date(farstDate).getDate()
      this.plansLastYearSelected = new Date(lastDate).getFullYear()
      this.plansLastMonSelected = new Date(lastDate).getMonth()
      this.plansLastDaySelect = new Date(lastDate).getDate()
      const farstTime = this.currentlyScheduledList[index].farstTime.split(':')
      const lastTime = this.currentlyScheduledList[index].lastTime.split(':')
      this.plansFarstTimeFarstInput = farstTime[0]
      this.plansFarstTimeLastInput = farstTime[1]
      this.plansLastTimeFarstInput = lastTime[0]
      this.plansLastTimeLastInput = lastTime[1]
      this.plansNameTextInput = this.currentlyScheduledList[index].name
      this.plansType = this.currentlyScheduledList[index].type
      this.plansContentInput = this.currentlyScheduledList[index].content
      this.plansDeleteFlag = this.currentlyScheduledList[index].deleteFlag
    },
    // TODO: 応対の編集
    receptionEdit (index) {
      const farstDate = new Date(this.receptionScheduledList[index].farstDate)
      const lastDate = new Date(this.receptionScheduledList[index].lastDate)
      this.receptionFarstYearSelected = new Date(farstDate).getFullYear()
      this.receptionFarstMonSelected = new Date(farstDate).getMonth()
      this.receptionFarstDaySelect = new Date(farstDate).getDate()
      this.receptionLastYearSelected = new Date(lastDate).getFullYear()
      this.receptionLastMonSelected = new Date(lastDate).getMonth()
      this.receptionLastDaySelect = new Date(lastDate).getDate()
      this.receptionName = this.receptionScheduledList[index].partnerName
      this.receptionGender = this.receptionScheduledList[index].partnerGender
      this.receptionContentInput = this.receptionScheduledList[index].content
      this.personInChargeInput = this.receptionScheduledList[index].personInCharge
      this.receptionDeleteFlag = this.receptionScheduledList[index].deleteFlag
      const registerDate = new Date(this.receptionScheduledList[index].orderDate)
      this.receptionYearDate = new Date(registerDate).getFullYear()
      this.receptionMonDate = new Date(registerDate).getMonth()
      this.receptionDayDate = new Date(registerDate).getDate()
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
html,body {
  max-height: 100% !important;
  bottom: 0 !important;
}

.border-title {
  border-left: solid 0.5em #0088ff;
}

.btn-danger {
    background-color: #0088ff !important;
    border-color: #0088ff !important;
}
</style>
